import { Stack } from '@mui/material';
import { get } from 'lodash';
import React, { FC, ReactElement, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LoadingBackdrop from '../../../../components/ui-component/loading/LoadingBackdrop';
import MuiSnackbar from '../../../../components/ui-component/mui-snackbar/MuiSnackbar';
import { PostRecord } from '../../../../lib/api/PostRecord';
import { APIS } from '../../../../lib/constants/apis';
import {
	ANTRAG_HALBJAHR_ART,
	ANTRAG_TYP,
	ANTRAGS_STATUS,
	NACHWEIS_BUTTON_SICHTBAR,
	NOCH_NICHT_MOEGLICH_TEXT,
} from '../../../../lib/constants/constant';
import { PAGES_URLS } from '../../../../lib/constants/routes';
import { enumT, getFieldNamefromDataPath } from '../../../../utils/helper';
import { AntragButton, AntragsButtonWrapper } from '../FoerderungUebersicht';

// import Schemas
import AntragSchema from '../../../../lib/paths/antrag_FULL_Paths.json';
import KostenPostionSchema from '../../../../lib/paths/kostenposition_FULL_Paths.json';
import NachweisPostionSchema from '../../../../lib/paths/nachweisposition_FULL_Paths.json';
import SchuljahrPostionSchema from '../../../../lib/paths/schluljahr_FULL_Paths.json';
import VerwendungsnachweisSchema from '../../../../lib/paths/verwendungsnachweis_FULL_Paths.json';
const P = AntragSchema.attributes;
const KP_P = KostenPostionSchema.attributes;
const NP_P = NachweisPostionSchema.attributes;
const SJ_P = SchuljahrPostionSchema.attributes;
const VN_P = VerwendungsnachweisSchema.attributes;

const FoerderAntragUebersicht: FC<{ application: any; schulJahr: any }> = ({ application, schulJahr }) => {
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);
	const [wsError, setWsError] = useState(false);

	const handleCreatebyType = async (type: string) => {
		const allKostenPostion = get(application, P.Antrag_Kostenpositions.path, []);
		try {
			setLoading(true);
			const vnData = {
				[getFieldNamefromDataPath(VN_P.Antrag.path)]: get(application, 'id'),
				[getFieldNamefromDataPath(VN_P.Status_Status.path)]: ANTRAGS_STATUS.inBearbeitung,
				[getFieldNamefromDataPath(VN_P.Allgemein_Nachweistyp.path)]: type,
				[getFieldNamefromDataPath(VN_P.Allgemein_Bewilligte_Foerdersumme.path)]: get(
					application,
					P.Zusammenfassung_Ueberblick_bewilligte_Foerdersumme.path
				),
			};
			const vnRes = await PostRecord(APIS.Verwendungsnachweis, { data: vnData });

			if (vnRes) {
				for (let i = 0; i < allKostenPostion.length; i++) {
					const eachKP = allKostenPostion[i];
					const nachweisData = {
						[getFieldNamefromDataPath(NP_P.Kostenposition.path)]: get(eachKP, 'id'),
						[getFieldNamefromDataPath(NP_P.Foerderprogramm.path)]: get(eachKP, KP_P.Allgemein_Foerderprogramm.path + '.id'),
						[getFieldNamefromDataPath(NP_P.Schule.path)]: get(eachKP, KP_P.Allgemein_Schule.path + '.id'),
						[getFieldNamefromDataPath(NP_P.Sparte.path)]: get(eachKP, KP_P.Allgemein_Sparte.path + '.id'),
						[getFieldNamefromDataPath(NP_P.Verwendungsnachweis.path)]: get(vnRes, 'data.id'),

						[getFieldNamefromDataPath(NP_P.Allgemein_Gruppierung_ID.path)]: get(eachKP, KP_P.Allgemein_Gruppierung_ID.path),
						[getFieldNamefromDataPath(NP_P.Allgemein_Position_ID.path)]: get(eachKP, KP_P.Allgemein_Position_ID.path),
						[getFieldNamefromDataPath(NP_P.Allgemein_Kostenart.path)]: get(eachKP, KP_P.Allgemein_Kostenart.path),

						[getFieldNamefromDataPath(NP_P.Allgemein_Lehrkraft_MKS.path)]: get(eachKP, KP_P.Allgemein_Lehrkraft_MKS.path),

						[getFieldNamefromDataPath(NP_P.Bewilligte_Foerderung_Klassen.path)]: get(eachKP, KP_P.Bewilligte_Foerderung_Klassen.path, null),
						[getFieldNamefromDataPath(NP_P.Bewilligte_Foerderung_Ustd_Woche.path)]: get(
							eachKP,
							KP_P.Bewilligte_Foerderung_Ustd_Woche.path,
							null
						),
						[getFieldNamefromDataPath(NP_P.Bewilligte_Foerderung_Uwo.path)]: get(eachKP, KP_P.Bewilligte_Foerderung_Uwo.path, null),
						[getFieldNamefromDataPath(NP_P.Bewilligte_Foerderung_Anstellung.path)]: get(
							eachKP,
							KP_P.Bewilligte_Foerderung_Anstellung.path,
							null
						),
						[getFieldNamefromDataPath(NP_P.Bewilligte_Foerderung_Honorarsatz.path)]: get(
							eachKP,
							KP_P.Bewilligte_Foerderung_Honorarsatz.path,
							null
						),
						[getFieldNamefromDataPath(NP_P.Bewilligte_Foerderung_Bewilligte_Foerderung.path)]: get(
							eachKP,
							KP_P.Bewilligte_Foerderung_bewilligte_Foerderung.path,
							null
						),

						[getFieldNamefromDataPath(NP_P.Tatsaechliche_Foerderung_Klassen.path)]: get(eachKP, KP_P.Bewilligte_Foerderung_Klassen.path, null),
						[getFieldNamefromDataPath(NP_P.Tatsaechliche_Foerderung_Ustd_Woche.path)]: get(
							eachKP,
							KP_P.Bewilligte_Foerderung_Ustd_Woche.path,
							null
						),
						[getFieldNamefromDataPath(NP_P.Tatsaechliche_Foerderung_Uwo.path)]: get(eachKP, KP_P.Bewilligte_Foerderung_Uwo.path, null),
						[getFieldNamefromDataPath(NP_P.Tatsaechliche_Foerderung_Anstellung.path)]: get(
							eachKP,
							KP_P.Bewilligte_Foerderung_Anstellung.path,
							null
						),
						[getFieldNamefromDataPath(NP_P.Tatsaechliche_Foerderung_Honorarsatz.path)]: get(
							eachKP,
							KP_P.Bewilligte_Foerderung_Honorarsatz.path,
							null
						),
						[getFieldNamefromDataPath(NP_P.Tatsaechliche_Foerderung_Bewilligte_U_Std.path)]: get(
							eachKP,
							KP_P.Bewilligte_Foerderung_Ustd_Woche.path,
							null
						) * get(eachKP, KP_P.Bewilligte_Foerderung_Uwo.path, 0),
						[getFieldNamefromDataPath(NP_P.Tatsaechliche_Foerderung_Tatsaechliche_U_Std.path)]: get(
							eachKP,
							KP_P.Bewilligte_Foerderung_Ustd_Woche.path,
							null
						) * get(eachKP, KP_P.Bewilligte_Foerderung_Uwo.path, 0),
						[getFieldNamefromDataPath(NP_P.Tatsaechliche_Foerderung_bewilligte_Sachkosten.path)]: get(
							eachKP,
							KP_P.Beantragte_Foerderung_Sachkosten.path,
							null
						),
						[getFieldNamefromDataPath(NP_P.Tatsaechliche_Foerderung_Tatsaechliche_Sachkosten.path)]: get(
							eachKP,
							KP_P.Beantragte_Foerderung_Sachkosten.path,
							null
						),
						[getFieldNamefromDataPath(NP_P.Bewilligte_Foerderung_Sachkosten.path)]: get(
							eachKP,
							KP_P.Beantragte_Foerderung_Sachkosten.path,
							null
						),
						[getFieldNamefromDataPath(NP_P.Bewilligte_Foerderung_bewilligte_Personalkosten.path)]: get(
							eachKP,
							KP_P.Bewilligte_Foerderung_beantragte_Personalkosten.path,
							null
						),
						[getFieldNamefromDataPath(NP_P.Tatsaechliche_Foerderung_Tatsaechliche_Foerderung.path)]: get(
							eachKP,
							KP_P.Bewilligte_Foerderung_bewilligte_Foerderung.path,
							null
						),
					};
					await PostRecord(APIS.Nachweisposition, { data: nachweisData });
				}
				navigate(PAGES_URLS.OnlineAntrag, { state: { id: get(vnRes, 'data.id'), api: APIS.Verwendungsnachweis } });
			}
		} catch (err: any) {
			setWsError(true);
			console.error('ERROR: Creating Nachweis ', err);
		} finally {
			setLoading(false);
		}
	};

	const checkIfValidForCreation = (checkHalbjahrCondition: boolean, frist: Date) => {
		return (
			checkHalbjahrCondition ?
				frist <= new Date() ?
					true
				:	false
			:	true
		);
	};

	const createButton = (key: string, title: string, name: string, description: string, onClick: () => void, disabled: boolean) => (
		<AntragsButtonWrapper key={key} title={title}>
			<AntragButton key={`${key}-button`} name={name} description={description} onClick={onClick} disabled={disabled} />
		</AntragsButtonWrapper>
	);

	const RenderVerwendungsnachweisButton = () => {
		const buttons: ReactElement[] = [];
		const halbjahr = get(application, P.Zusammenfassung_Ueberblick_Halbjahr.path);
		const verwendungsnachweis = get(application, P.Antrag_Verwendungsnachweiss.path, []);
		const status = get(application, P.Status_Status.path);

		// auf true setzen wenn halbjahr geprüft werden soll
		const checkHalbjahrCondition = false;
		const datumFristErstesHalbjahrVN = new Date(get(schulJahr, SJ_P.erste_Halbjahr.schema.attributes.erste_Halbjahr_Frist_Fuer_VN.path));

		const datumFristZweitesHalbjahrZN = new Date(get(schulJahr, SJ_P.zweite_Halbjahr.schema.attributes.Frist_Fuer_ZN.path));
		const datumFristZweitesHalbjahrVN = new Date(get(schulJahr, SJ_P.zweite_Halbjahr.schema.attributes.zweite_Halbjahr_Frist_Fuer_VN.path));
		const vnFrist = halbjahr === ANTRAG_HALBJAHR_ART.ersteHalbJahr ? datumFristErstesHalbjahrVN : datumFristZweitesHalbjahrVN;

		const addButton = (type: string, title: string, deadline: Date) => {
			const existingVN = verwendungsnachweis.find((item: any) => get(item, VN_P.Allgemein_Nachweistyp.path) === type);
			const isValidForCreation = checkIfValidForCreation(checkHalbjahrCondition, deadline);
			buttons.push(
				(
					existingVN // Wenn VN gefunden wird, einfach Button immer anzeigen
				) ?
					createButton(
						title, // key
						title, // Title über dem Button
						title, // Button Name
						enumT(get(existingVN, VN_P.Status_Status.path)), // Status VN im Button (secondary text)
						() =>
							navigate(PAGES_URLS.OnlineAntrag, {
								state: { id: get(existingVN, 'id'), api: APIS.Verwendungsnachweis },
							}),
						!NACHWEIS_BUTTON_SICHTBAR.includes(status)
					)
				:	/* Wenn kein VN existiert, dann Button trotzdem anzeigen aber muss geprüft werden, ob VN erstellt werden kann. Geprüft wird mit Funktion isValidForCreation */
					createButton(
						title,
						title,
						isValidForCreation ? `${title} erstellen` : NOCH_NICHT_MOEGLICH_TEXT,
						'',
						() => handleCreatebyType(type),
						!isValidForCreation
					)
			);
		};

		// Immer statische Button (Disabled) anzeigen, wenn VN noch nicht erstellt werden kann
		if (!NACHWEIS_BUTTON_SICHTBAR.includes(status) && verwendungsnachweis.length === 0) {
			return (
				<>
					{halbjahr === ANTRAG_HALBJAHR_ART.zweiteHalbJahr &&
						createButton(ANTRAG_TYP.Zwischenmeldung, ANTRAG_TYP.Zwischenmeldung, NOCH_NICHT_MOEGLICH_TEXT, '', () => {}, true)}
					{createButton(ANTRAG_TYP.Verwendungsnachweis, ANTRAG_TYP.Verwendungsnachweis, NOCH_NICHT_MOEGLICH_TEXT, '', () => {}, true)}
				</>
			);
		}

		if (halbjahr !== ANTRAG_HALBJAHR_ART.ersteHalbJahr) {
			addButton(ANTRAG_TYP.Zwischenmeldung, ANTRAG_TYP.Zwischenmeldung, datumFristZweitesHalbjahrZN);
		}
		addButton(ANTRAG_TYP.Verwendungsnachweis, ANTRAG_TYP.Verwendungsnachweis, vnFrist);

		return <>{buttons}</>;
	};

	return (
		<>
			<MuiSnackbar error={true} showSnackbar={wsError} closeSnackbar={() => setWsError(false)} alertMessage='Etwas ist schief gelaufen' />
			<LoadingBackdrop open={loading} />
			<Stack direction={'row'} justifyContent={'space-between'}>
				<AntragsButtonWrapper title='Antrag'>
					<AntragButton
						name='Antrag'
						description={enumT(get(application, P.Status_Status.path))}
						onClick={() => {
							navigate(PAGES_URLS.OnlineAntrag, {
								state: {
									id: get(application, 'id'),
									api: APIS.Antrag,
								},
							});
						}}
					/>
				</AntragsButtonWrapper>
			</Stack>
			<RenderVerwendungsnachweisButton />
		</>
	);
};

export default FoerderAntragUebersicht;
